import Button from "./Button"

const ButtonList=()=>{
    return (
        <div className="flex items-center w-full p-2 overflow-y-auto">
            <Button name="All"/>
            <Button name="Gaming"/>
            <Button name="Live"/>
            <Button name="Songs"/>
            <Button name="Movies"/>
            <Button name="Sports"/>
            <Button name="Latest"/>
            <Button name="F1"/>
            <Button name="Sci-Fi"/>
            <Button name="E-sports"/>
            <Button name="Valorant"/>
            <Button name="Cricket"/>
            <Button name="All"/>
            <Button name="Gaming"/>
            <Button name="Live"/>
            <Button name="Songs"/>
            <Button name="Cricket"/>
            <Button name="All"/>
        </div>
    )
}
export default ButtonList